import { render, staticRenderFns } from "./page-build.vue?vue&type=template&id=6f13fa11&scoped=true"
import script from "./page-build.vue?vue&type=script&lang=js"
export * from "./page-build.vue?vue&type=script&lang=js"
import style0 from "./page-build.vue?vue&type=style&index=0&id=6f13fa11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f13fa11",
  null
  
)

export default component.exports